import React from 'react';
import { FeedbackData } from '../api/client';
import './AIFeedback.css';

interface AIFeedbackProps {
  feedback: FeedbackData | null;
}

const progressLabel = (progress?: string): string => {
  if (!progress) return 'стабильно';
  const lower = progress.toLowerCase();
  if (lower.includes('улучш') || lower.includes('прогресс') || lower.includes('рост')) return 'улучшение';
  if (lower.includes('регресс') || lower.includes('сниж') || lower.includes('спад')) return 'регресс';
  if (lower.includes('стаб')) return 'стабильно';
  return progress;
};

export const AIFeedback: React.FC<AIFeedbackProps> = ({ feedback }) => {
  if (!feedback || typeof feedback.feedback !== 'string') {
    return (
      <div className="ai-feedback ai-feedback-muted">
        <div className="ai-feedback-header">
          <h3>Разбор тренера</h3>
        </div>
        <p className="feedback-text">Обратная связь недоступна</p>
      </div>
    );
  }

  const recommendations = Array.isArray(feedback.recommendations) ? feedback.recommendations : [];

  return (
    <div className="ai-feedback">
      <div className="ai-feedback-header">
        <h3>Разбор тренера</h3>
      </div>

      <div className="ai-feedback-content">
        <p className="feedback-text">{feedback.feedback}</p>

        {feedback.progress && (
          <div className="progress-indicator">
            <span className="progress-label">Прогресс:</span>
            <span className="progress-value">
              {progressLabel(feedback.progress)}
            </span>
          </div>
        )}

        {recommendations.length > 0 && (
          <div className="recommendations">
            <h4>Рекомендации</h4>
            <ul>
              {recommendations.map((rec, idx) => (
                <li key={idx}>{rec}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
